module.exports = __webpack_public_path__ + "img/IMG_2368_L_Wood.076803cf.jpg";